export type StoredGuest = { participantId: string; token: string; name: string }
type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>
const key = (tournamentId: string) => `fem.guest.${tournamentId}`
// Letto solo a chiamata (non al momento dell'import): l'ambiente Vitest 'node' non ha `localStorage`.
const storage = (): StorageLike | null => (typeof localStorage === 'undefined' ? null : localStorage)

export function loadGuest(tournamentId: string, s: StorageLike | null = storage()): StoredGuest | null {
  try {
    const raw = s?.getItem(key(tournamentId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<StoredGuest>
    return parsed.participantId && parsed.token && parsed.name
      ? { participantId: parsed.participantId, token: parsed.token, name: parsed.name }
      : null
  } catch { return null }
}
export function saveGuest(tournamentId: string, guest: StoredGuest, s: StorageLike | null = storage()): void {
  try { s?.setItem(key(tournamentId), JSON.stringify(guest)) } catch { /* modalità privata: l'ospite resta collegato solo per la sessione */ }
}
export function clearGuest(tournamentId: string, s: StorageLike | null = storage()): void {
  try { s?.removeItem(key(tournamentId)) } catch { /* idem */ }
}
/** `?join=<token>` dal link di ricollegamento generato dall'admin. */
export const joinLinkToken = (search: string): string | null => new URLSearchParams(search).get('join')
